<template>
    <div>
        <table class="table">
            <thead>
                <tr>
                    <th v-for="field in fields" style="width: 25%">
                        {{ field }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <template v-for="(row, index) in data">
                    <tr v-if="row.country">
                        <td
                            colspan="4"
                            :class="{
                                'px-0': true,
                                'border-top-none': index != 0,
                            }"
                        >
                            <div class="accordion" role="tablist">
                                <div no-body class="mb-1">
                                    <b-card-header
                                        class="p-1 list-country"
                                        role="tab"
                                    >
                                        <span
                                            v-b-toggle="
                                                `accordion-${index}-${row.category}`
                                            "
                                            class="d-flex justify-content-between p-2"
                                        >
                                            <span class="d-flex country-span">
                                                <span
                                                    v-if="row.country != 'GL'"
                                                    :class="`mb-1 fi fi-${getCountryCodeFormatted(
                                                        row.country
                                                    )}`"
                                                ></span>
                                                <img
                                                    v-else
                                                    :src="GL_ICON"
                                                    width="18.66"
                                                    height="16.99"
                                                />
                                                &nbsp;&nbsp;
                                                {{ row.country }}

                                                <span
                                                    @click="
                                                        ($event) =>
                                                            $event.stopPropagation()
                                                    "
                                                >
                                                    <b-form-checkbox
                                                        v-model="row.status"
                                                        class="ml-5 custom-switch"
                                                        name="check-button"
                                                        switch
                                                        size="md"
                                                        @change="
                                                            (val) =>
                                                                handleCheckboxChange(
                                                                    row,
                                                                    val
                                                                )
                                                        "
                                                    />
                                                </span>
                                            </span>

                                            <i class="icon-caret-down"></i>
                                        </span>
                                    </b-card-header>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <template v-if="row.country && row.data">
                        <b-collapse
                            :id="`accordion-${index}-${row.category}`"
                            tag="tr"
                        >
                            <td colspan="4" class="px-0 border-top-none">
                                <table
                                    calss="table innerTable"
                                    style="width: 100%"
                                >
                                    <tr v-for="(item, innerIndex) in row.data">
                                        <td
                                            :class="{
                                                'border-top-none':
                                                    innerIndex == 0,
                                            }"
                                            style="width: 25%"
                                        >
                                            <img
                                                v-b-tooltip.hover
                                                :title="item.description || ''"
                                                :src="INFO_ICON"
                                                width="15px"
                                                height="15px"
                                                class="d-inline mx-3 cursor-pointer"
                                            />{{ item.title }}
                                        </td>
                                        <td
                                            :class="{
                                                'border-top-none':
                                                    innerIndex == 0,
                                            }"
                                            style="width: 25%"
                                        >
                                            {{ item.publisher }}
                                        </td>
                                        <td
                                            :class="{
                                                'border-top-none':
                                                    innerIndex == 0,
                                            }"
                                            style="width: 25%"
                                        >
                                            <base-status
                                                :status-type="
                                                    item.status == true
                                                        ? 'active'
                                                        : 'In-Active'
                                                "
                                            ></base-status>
                                        </td>
                                        <td
                                            :class="{
                                                'border-top-none':
                                                    innerIndex == 0,
                                            }"
                                            style="width: 25%"
                                        >
                                            <b-form-checkbox
                                                v-model="item.status"
                                                class="ml-5 custom-switch"
                                                name="check-button"
                                                switch
                                                size="md"
                                                @change="
                                                    (val) =>
                                                        handleCheckboxChange(
                                                            item,
                                                            val
                                                        )
                                                "
                                            />
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </b-collapse>
                    </template>
                    <template v-else>
                        <tr v-for="item in row.data">
                            <td style="width: 25%">
                                <img
                                    v-b-tooltip.hover
                                    :title="item.description || ''"
                                    :src="INFO_ICON"
                                    width="15px"
                                    height="15px"
                                    class="d-inline mx-3 cursor-pointer"
                                />
                                {{ item.title }}
                            </td>
                            <td style="width: 25%">{{ item.publisher }}</td>
                            <td style="width: 25%">
                                <base-status
                                    :status-type="
                                        item.status == true
                                            ? 'active'
                                            : 'in-active'
                                    "
                                ></base-status>
                            </td>
                            <td style="width: 25%">
                                <b-form-checkbox
                                    v-model="item.status"
                                    class="ml-5 custom-switch"
                                    name="check-button"
                                    switch
                                    size="md"
                                    @change="
                                        (val) => handleCheckboxChange(item, val)
                                    "
                                />
                            </td>
                        </tr>
                    </template>
                </template>
            </tbody>
        </table>
    </div>
</template>
<script>
import GL_ICON from '@/assets/images/GL.png'
import INFO_ICON from '@/assets/images/info.png'

export default {
    props: {
        data: { type: Array, default: () => [] },
        fields: { type: Array, default: () => [] },
        addFieldToUpdate: { type: Function, default: () => {} },
    },
    data() {
        return {
            checkBoxModel: false,
            activeAccordionId: '',
            GL_ICON: GL_ICON,
            INFO_ICON: INFO_ICON,
            tableData: [
                // {
                //   id: 1,
                //   country: 'Pakistan',
                //   items:[
                //     { title: "Supreme Court of Pakistan", publisher: "Idenfo", status: "active", allow: true },
                //     { title: "High Court", publisher: "Idenfo", status: "active", allow: true },
                //   ]
                // },
            ],
        }
    },
    watch: {
        checkBoxModel(val) {
            console.log('val')
            console.log(val)
        },
        data(value) {
            console.log('data', value)
        },
        // data(value){
        //   if(value && value.length){
        //     let changedData = value.reduce((prev, acc)=>{
        //       if(acc.country) {
        //         let added = false;
        //         for(let i=0; i<prev.length; i++) {
        //           if(prev[i].country == acc.country) {
        //             prev[i].items.push(acc);
        //             added = true;
        //             break;
        //           }
        //         }
        //         if(!added) {
        //           prev.push({
        //             country: acc.country,
        //             items: [acc, ],
        //           })

        //         }
        //       } else {
        //         prev.push(acc);
        //       }
        //       return prev;
        //     }, []);
        //     console.log("changed", changedData)
        //     this.tableData = changedData;
        //   }
        // }
    },
    methods: {
        activate(event) {
            this.activeAccordionId = event.currentTarget.id
        },
        stopPropagation(event) {
            console.log('stopping')
            event.stopPropagation()
        },
        handleCheckboxChange(item, status) {
            this.addFieldToUpdate({ ...item, status: status })
        },
        getCountryCodeFormatted(code) {
            const changed = {
                uk: 'gb',
            }
            let formatted = code.toLowerCase()
            return changed[formatted] || formatted
        },
    },
}
</script>

<style>
.list-country {
    height: 30px;
    font: 12px;
}

.country-span {
    margin-top: -8px;
}

.icon-caret-down,
.icon-caret-up {
    font-size: 7px;
}

.border-top-none {
    border-top: none !important;
    padding-top: 0px !important;
}

.innerTable tr:first-child td {
    border-top: none !important;
    padding-top: 0px !important;
}

/* .custom-switch:focus:not(:checked)~.custom-control-label::before {
  border-color: red !important;
} */
.custom-control-input:checked ~ .custom-control-label::before {
    color: #fff;
    border-color: #108274;
    background-color: #108274;
}

table tr {
    text-align: center;
}
</style>
